const locale = {
  "inspections.accessibility":
    "Acessibilidade para pessoas expostas ao material de amianto",
  "inspections.amphibolesPresence":
    "Presença de anfibólios (crocidolita, amosita, tremolita, antofilita e/ou actinolita)",
  "inspections.asbestosVariety": "Variedade de amianto",
  "inspections.between1150": "Entre 11 e 50 metros lineares e/ou quadrados",
  "inspections.between13": "De 1 a 3",
  "inspections.between2501000": "Salas entre 250 e 1000 metros cúbicos",
  "inspections.between410": "De 4 a 10",
  "inspections.difficultyAccessible":
    "De difícil acesso no uso diário da instalação (baixa acessibilidade). Altura acima de 2,2 metros. Interação ocasional com MCA possível.",
  "inspections.easyAccessible":
    "De fácil acesso no uso diário da instalação (acessibilidade média). Interação fácil com MCA possível.",
  "inspections.equipmentLocation": "Localização do equipamento ou instalação",
  "inspections.extentQuantity": "Extensão / quantidade de material de amianto",
  "inspections.frequent":
    "O material está em uma área ruidosa e vibrante (salas de máquinas). Atividades frequentes são realizadas que envolvem o manuseio do material (mais de uma vez por mês).",
  "inspections.friability": "Friabilidade do material",
  "inspections.greatDamage":
    "Danos severos ou destacamento das camadas que compõem materiais pulverizados ou 'flockings' e isolamentos térmicos. Detritos de amianto visíveis.",
  "inspections.highAccessible":
    "Acessível para qualquer uso (alta acessibilidade). Altura abaixo de 2,2 metros. Interação frequente com MCA possível.",
  "inspections.highFriability":
    "Isolamentos não encapsulados e materiais pulverizados ou 'flockings'. Material de ALTA FRIABILIDADE, fragmenta-se muito facilmente apenas ao toque, possivelmente destacando-se.",
  "inspections.inaccessible": "Inacessível no uso diário da instalação",
  "inspections.largeAndWellVentilated":
    "Em espaços grandes e bem ventilados > 100 m³",
  "inspections.lessThan10": "Menos de 10 metros lineares e/ou quadrados",
  "inspections.lessThan250":
    "Espaços menores que 250 metros cúbicos. Espaços que atuam como plenos em um sistema de ar condicionado, independentemente do tamanho, ou materiais sujeitos a correntes de ar.",
  "inspections.littleDamage":
    "Poucos danos: pequenos arranhões ou marcas, bordas quebradas em placas, azulejos, etc.",
  "inspections.lowFriability":
    "Materiais pulverizados ou 'flockings' ou isolamentos selados; placas isolantes (com a face exposta pintada ou encapsulada), cimento-amianto, etc. Material de BAIXA FRIABILIDADE, pode ser danificado manualmente, mas com dificuldade. O material pode ser danificado por impactos. O material tem base de cimento e deixa grânulos na mão, mas sem poeira. O material perdeu parcialmente sua integridade.",
  "inspections.materialStatus":
    "Condição do material (ou possível deterioração)",
  "inspections.mediumDamage":
    "Danos médios: quebras significativas de materiais ou grandes quebras em pequenas áreas onde materiais danificados podem liberar fibras, danos visíveis por água.",
  "inspections.mediumFriability":
    "Placas isolantes não encapsuladas ou isolamentos e materiais pulverizados ou 'flockings' encapsulados. Material de MÉDIA FRIABILIDADE, fácil de fragmentar com simples pressão manual. Peças podem ser removidas simplesmente à mão. O material tem base de cimento e deixa um resíduo pulverulento nas mãos quando esfregado.",
  "inspections.moreThan10": "Mais de 10",
  "inspections.moreThan51": "Mais de 51 metros quadrados e/ou lineares",
  "inspections.never":
    "Nenhuma atividade é realizada que envolva o manuseio ou perturbação do material",
  "inspections.noDamage": "Bom estado: sem danos visíveis",
  "inspections.noFriability":
    "Compostos reforçados contendo amianto, plásticos reforçados, resinas, vinis, etc. Material NÃO FRIÁVEL, duro e não pode ser danificado manualmente. É necessário um objeto para danificá-lo. O material está intacto.",
  "inspections.none": "Nenhum",
  "inspections.occasionally":
    "Atividades são realizadas que envolvem circulação pela área onde o material de amianto está localizado, ou ações que envolvem o manuseio do material muito ocasionalmente (menos de uma vez por mês)",
  "inspections.occasionallyAccessible":
    "Em espaços fechados, acessível ocasionalmente",
  "inspections.onlyChrysotile": "Apenas crisotila",
  "inspections.outdoorOrEncapsulated": "Ao ar livre ou totalmente encapsulado",
  "inspections.potentiallyExposed":
    "Número de pessoas potencialmente expostas (incluindo trabalhadores e usuários)",
  "inspections.smallQuantities":
    "Pequenas quantidades, 1 unidade (junta, corda, cabo, placa, tubo de descida)",
  "inspections.technicalAccessibility": "Acessibilidade técnica",
  "titularidad-privado": "PRIVADO",
  "titularidad-publico": "PÚBLICO",
  "titularidad-todo": "TODOS",
  "uso_del_edificio_Servicios Públicos": "Serviços públicos",
  address: "Endereço",
  amortization_graph: "Gráfico de amortização",
  area: "Área",
  ASBESTOS_INVENTORY: "Inventário de amianto",
  asbestos_susceptibility: "Susceptibilidade ao amianto",
  asbestos_type: "Tipo de amianto",
  asbestos: "Amianto",
  asbestus_data: "Dados de amianto",
  attachments: "Anexos",
  available_area: "Área disponível",
  available_trees: "Árvores disponíveis",
  base_layer_selector: "Camada base",
  base_layer: "Camada base",
  biomass: "Biomassa",
  building_age: "Idade do edifício",
  building_creation_date: "Data de construção do edifício",
  catastro_description:
    "Informações relevantes sobre edifícios obtidas diretamente do cadastro.",
  catastro_title: "Cadastro",
  center_aoi: "Centro da AOI",
  center_user: "Centrar usuário",
  click_to_select_a_project: "Meus projetos",
  co2: "CO₂",
  coming_soon: "Indisponível",

  common_name: "Nome comum",
  copying_element: "Copiando elemento",
  creating_element: "Criando elemento",
  creating_new_element: "Criando novo elemento",
  crown_diameter: "Diâmetro da copa",
  current_use: "Uso atual",
  cyclosm_description:
    "Permite visualizar a altitude e o relevo do terreno através de curvas de nível, bem como elementos naturais (rios, montanhas, florestas) e artificiais (ruas, estradas, edifícios).",
  cyclosm_title: "Mapa topográfico",
  dashboard: "Painel de controle",
  delete_attachment_body:
    "Tem certeza de que deseja excluir este anexo? Esta ação não pode ser desfeita.",
  delete_attachment_title: "Excluir anexo",
  delete_element_body:
    "Tem certeza de que deseja excluir este elemento? Esta ação não pode ser desfeita.",
  delete_element_title: "Excluir elemento",
  delete_image: "Excluir imagem",
  delete: "Excluir",
  deleting_element: "Excluindo elemento",
  deleting_image: "Excluindo imagem",
  description: "Descrição",
  discard_changes_body: "Você tem alterações não salvas. Deseja descartá-las?",
  discard_changes_title: "Descartar alterações",
  discard: "Descartar",
  district_b_code: "Código do distrito B",
  district_bar_code: "Código de barras do distrito",
  district_code: "Código do distrito",
  district_name: "Nome do distrito",
  district_tx: "Distrito TX",
  edification_data: "Dados da edificação",
  EDIFICATION_INVENTORY: "Inventário de edificações",
  edification: "Edificação",
  edit_feature: "Editar elemento",
  edit: "Editar",
  element_copied_successfully: "Elemento copiado com sucesso",
  element_copying_error: "Erro ao copiar o elemento",
  element_created_successfully: "Elemento criado com sucesso",
  element_creating_error: "Erro ao criar o elemento",
  element_deleted_successfully: "Elemento excluído com sucesso",
  element_type: "Tipo de elemento",
  energy_graph: "Gráfico de energia",
  exit_edition: "Sair da fotointerpretação",
  filters: "Filtros",
  form: "Formulário",
  fx_creation: "Data de criação",
  fx_modification: "Data de modificação",
  google_satellite_description:
    "Dos serviços do Google. Em certas regiões, fornece imagens mais atualizadas e de maior resolução do que as fornecidas pelo IGN.",
  google_satellite_title: "Google",
  has_lab_measures: "Possui medições laboratoriais",
  header_category: "Categoria",
  header_description: "Descrição",
  header_image: "Imagem",
  header_tag: "Tags",
  header_title: "Título",
  height: "Altura",
  image_deleted_successfully: "Imagem excluída com sucesso",
  image_uploaded_successfully: "Imagem carregada com sucesso",
  images: "Imagens",
  ine_code: "Código INE",
  info: "Informações",

  inspection_type: "Tipo de inspeção",
  is_asbestos: "Contém amianto",
  lab_measure_note: "Nota da medição laboratorial",
  lab_measure_ref_code: "Código de referência da medição laboratorial",
  layer_attributions: "Atribuições da camada",
  layer_groups: "Grupos de camadas",
  layer_visualization_control: "Controle de visualização de camadas",
  layers: "Camadas",
  leaf_type: "Tipo de folha",
  legend: "Legenda",
  less: "Menos",
  link_catastro: "Link para o cadastro",
  link_maps: "Link para mapas",
  link: "Link",
  loading_data: "Carregando dados",
  loading_legend: "Carregando legenda",
  loading_map: "Carregando mapa",
  log_out: "Sair",
  m2_catastro: "Cadastral",
  made_by: "Feito por",
  main_species: "Espécie principal",
  major_neighborhood: "Bairro principal",
  more: "Mais",
  municipality: "Município",
  n_elements_inside: "Número de elementos",
  n_ref_catastral: "Número de referência cadastral",
  name: "Nome",
  neighborhood_code: "Código do bairro",
  neighborhood_mt: "MT do bairro",
  neighborhood_name: "Nome do bairro",
  neighborhood_number: "Número do bairro",
  no_attributions: "Sem atribuições",
  no_changes_made: "Nenhuma alteração a ser salva",
  no_info_to_display: "Localização vazia",
  no: "Não",
  obtaining_data: "Obtendo dados",
  open_in_new_tab: "Abrir em nova aba",
  osm_description:
    "Mapa baseado no Open Street Map que permite visualizar nomes de ruas e edifícios de interesse.",
  osm_title: "Mapa de ruas",
  owner: "Proprietário",
  pa: "Profundidade",
  percent: "Porcentagem",
  pnoa_description:
    "Este mapa base utiliza o WMTS fornecido pelo PNOA para uma visualização clara de fotografias aéreas de alta resolução do terreno.",
  pnoa_title: "Aéreo",
  prev_state: "Estado anterior",
  print: "Imprimir",
  prop_state: "Estado proposto",
  province: "Província",
  questionsPhase1: "Ambiente",
  questionsPhase2: "Material",
  questionsPhase3: "Soma dos valores dos fatores",
  read_only: "somente leitura",
  risk_final_value: "Valor final de risco",
  risk_form_value: "Valor do formulário de risco",
  risk_simplify_type: "Tipo de simplificação do risco",
  risk_type_used: "Tipo de risco utilizado",
  save_changes_body: "Deseja salvar as alterações antes de sair?",
  save_changes_title: "Salvar alterações",
  save: "Salvar",
  season: "Estação",
  select_project: "Selecionar um projeto",
  selected_point: "Ponto selecionado",
  selection_details: "Detalhes da seleção",
  shape_length: "Comprimento da forma",
  show_layer_attributions: "Mostrar atribuições da camada",
  show_more: "Mostrar mais",
  simple: "Simples",
  solar_data: "Dados solares",
  species_count: "Número de espécies",
  species: "Espécies",
  status: "Estado",
  susceptibility_label_alta: "Alta",
  susceptibility_label_baja: "Baixa",
  susceptibility_label_media: "Média",
  susceptibility_label_muy_alta: "Muito alta",
  susceptibility_title:
    "Susceptibilidade mínima à presença de amianto representada",
  table: "Tabela",
  title: "Título",
  titularidad: "Titularidade",
  to: "Até",
  toggle_visibility: "Alternar visibilidade",
  tooltipTeledeteccion: "Fotointerpretação",
  trees: "Árvores",
  txt_description_title_information:
    "Nesta ferramenta, você pode obter um orçamento para serviços de detecção remota de amianto para municípios, bem como análises que o ajudarão a entender e fornecer informações relevantes para seu cliente.",
  txt_description_title:
    "Censo de instalações com presença de amianto nos municípios, obrigatório segundo a Lei 07/2022",
  txt_description:
    "Os municípios são obrigados a realizar um censo das instalações e locais com amianto, incluindo um cronograma para sua remoção, conforme a Lei 07/2022, de 8 de abril, sobre resíduos e solos contaminados para uma economia circular. Cumpra facilmente com a Lei 07/2022 com nossa solução.\nA Agforest oferece a solução completa para o censo de amianto no seu município, utilizando algoritmos de inteligência artificial e imagens de satélite para detectar amianto na sua localidade.",
  txt_footer_legal: "Aviso legal",
  txt_footer_privacity: "Política de privacidade e cookies",
  type: "Tipo",
  undo: "Desfazer",
  uploading_image: "Carregando imagem",
  usage: "Uso",
  uso_del_edificio_Agrícola: "Agrícola",
  uso_del_edificio_Industrial: "Industrial",
  uso_del_edificio_Oficinas: "Escritórios",
  uso_del_edificio_Otros: "Outros",
  uso_del_edificio_Residencial: "Residencial",
  uso_del_edificio_Retail: "Comercial",
  uso_del_edificio: "Uso do edifício",
  visibility: "Opacidade",
  visualization_selector: "Visualização",
  visualization: "Visualização",
  website: "Website",
  write_an_address: "Digite um endereço",
  years: "Anos",
  yes: "Sim",
  zonas_catastro_description:
    "Este mapa combina duas camadas de informação: zonas construídas obtidas do cadastro e fotografias aéreas da região.",
  zonas_catastro_title: "Aéreo + Cadastro",
  zoom_in: "Ampliar",
  zoom_out: "Reduzir",
  MCA: "MCA - Contém amianto",
  MPCA: "MPCA - Possível amianto",
  NOMCA: "NOMCA - Sem amianto",
  PRELIMINAR: "Preliminar",
  BASICO: "Básico",
  DETALLADO: "Detalhado",
  CRISOTILO: "Crisótilo",
  ASBESTOS: "Amianto",
  CUBIERTA: "Cobertura",
  PARAMENTO: "Parede",
  material: "Material",

  adhesives_cements_sealants: "Adesivos, cimentos, selantes",
  adhesives: "Adesivos",
  adhesive_cement: "Cimento adesivo",
  caulking: "Calafetagem",
  cement: "Cimento",
  duct_adhesive: "Adesivo para dutos",
  finishing_cement: "Cimento de acabamento",
  furnace_cement: "Cimento para fornos",
  insulating_cement: "Cimento isolante",
  joint_cement: "Cimento para juntas",
  masonry_cement: "Cimento para alvenaria",
  putties: "Mastiques",
  mortar: "Argamassa",
  plastic_cement: "Cimento plástico",
  sealant: "Selante",

  asbestos_paper_board_roll: "Papel de amianto, rolo de placa, placa",
  asbestos_paper: "Papel de amianto",
  corrugated_paper: "Papel ondulado",
  flexible_board: "Placa flexível",
  millboard: "Cartão resistente ao calor",
  permanent_board: "Placa permanente",
  roll: "Rolo",
  vinyl_wallpaper: "Papel de parede vinílico",

  automotive_materials_friction: "Materiais automotivos, fricção",
  brake_linings: "Revestimentos de freio",
  brake_pads: "Pastilhas de freio",
  brakes: "Freios",
  clutch_linings: "Revestimentos de embreagem",
  disc_brakes: "Freios a disco",
  drum_brakes: "Freios a tambor",
  elevator_brake_shoes: "Sapatas de freio de elevador",
  transmission_plates: "Placas de transmissão",

  cement_pipes_boards_sheets_plastics:
    "Tubos de cimento, placas, folhas, plásticos",
  asbestos_board: "Placa de amianto",
  asbestos_sheets: "Folhas de amianto",
  cement_pipes: "Tubos de cimento",
  plastics: "Plásticos",
  stone_coating: "Revestimento de pedra",

  clay_compounds_paints_plasters: "Argilas, compostos, tintas, rebocos",
  acoustic_plaster: "Reboco acústico",
  asphalt: "Asfalto",
  filler: "Massa de enchimento",
  finishing: "Acabamento",
  joint_compound: "Massa para juntas",
  paint: "Tinta",
  patching: "Remendos",
  plaster: "Gesso",
  putty: "Massa",
  putty_compounds: "Compostos de massa",

  electrical_mechanical_products: "Produtos elétricos e mecânicos",
  boilers: "Caldeiras",
  cables_wires: "Cabos e fios",
  electrical_boards: "Quadros elétricos",
  furnaces: "Forno industrial",
  generators: "Geradores",
  heating_ducts: "Dutos de aquecimento",
  pumps: "Bombas",
  turbines: "Turbinas",
  valve_rings: "Anéis de válvula",
  valves: "Válvulas",
  weather_resistant_jackets: "Revestimentos resistentes ao tempo",
  wiring_insulation: "Isolamento de fiação",

  flooring_tiles: "Pisos, azulejos",
  ceiling_tiles: "Placas de teto",
  tiles: "Azulejos",
  flooring: "Piso",
  slabs: "Lajes",
  vinyl_linoleum_floors: "Pisos vinílicos e de linóleo",
  wall_tiles: "Azulejos de parede",

  gaskets_packings_sealing_materials:
    "Juntas, empacotamentos, materiais de vedação",
  braided_packing: "Empacotamento trançado",
  gasket_material: "Material de junta",
  gaskets: "Juntas",
  packing_material: "Material de empacotamento",
  rope_packing: "Empacotamento de corda",
  sheet_packing: "Empacotamento de folha",

  household_products: "Produtos domésticos",
  agricultural_filler: "Enchimento agrícola",
  attic_insulation: "Isolamento de sótão",
  cigarette_filters: "Filtros de cigarro",
  clay_pots: "Potes de barro",
  fertilizer: "Fertilizante",
  exhaust_hoods: "Capôs de exaustão",
  iron_stands: "Suportes de ferro",
  ironing_board_covers: "Capas de tábua de passar",
  lab_hoods: "Capelas de laboratório",
  potting_mixes: "Misturas para vasos",
  stove_mats: "Tapetes de fogão",

  panels_drywall_wall_coverings: "Painéis, drywall, revestimentos de parede",
  acoustic_panels: "Painéis acústicos",
  drywall: "Drywall",
  marine_panel: "Painel marítimo",
  panels: "Painéis",
  gypsum_board: "Placa de gesso",
  wallboard: "Revestimento de parede",
  pipe_covering_block: "Revestimento de tubo e bloco",
  block_insulation: "Isolamento em bloco",
  calcium_silicate: "Silicato de cálcio",
  duct_insulation: "Isolamento de duto",
  insulation: "Isolamento",
  magnesia: "Magnésia",
  pipe_insulation: "Isolamento de tubo",
  preformed_pipe_wrap: "Revestimento de tubo pré-formado",
  sponge_block: "Bloco esponjoso",
  sleeveless_jacket: "Jaqueta sem mangas",

  protective_clothing: "Roupas de proteção",
  aprons: "Aventais",
  asbestos_helmet: "Capacete de amianto",
  dust_masks: "Máscaras contra poeira",
  glassblowers_mittens: "Luvas de sopradores de vidro",
  gloves: "Luvas",
  lab_gloves: "Luvas de laboratório",
  mittens: "Luvas grossas",
  respirators: "Respiradores",
  sleeves: "Mangas",
  textile_garments: "Vestuário têxtil",

  protective_fireproof_coatings:
    "Revestimentos protetores e resistentes ao fogo",
  asbestos_curtains: "Cortinas de amianto",
  asbestos_spray: "Spray de amianto",
  boiler_coating: "Revestimento de caldeira",
  fireproof_blankets: "Cobertores antifogo",
  fire_dampers: "Amortecedores de fogo",
  fire_doors: "Portas corta-fogo",
  fireproof_cement: "Cimento antifogo",
  fireproof_materials: "Materiais resistentes ao fogo",
  insulating_coating: "Revestimento isolante",
  roof_coating: "Revestimento de telhado",
  textured_coatings: "Revestimentos texturizados",
  coating: "Revestimento",

  raw_asbestos: "Amianto bruto",
  asbestos_fiber: "Fibra de amianto",
  fake_snow: "Neve artificial",
  calsilite_silicate: "Silicato de Calsilite",
  talc_powder: "Pó de talco",
  transite: "Transite",
  vermiculite: "Vermiculita",

  refractory_products: "Produtos refratários",
  castables: "Materiais moldáveis",
  refractory_brick: "Tijolo refratário",
  marinite: "Marinite",
  refractory_cement: "Cimento refratário",

  rope_wick_cord_tape_cork: "Corda, pavio, cordão, fita, cortiça",
  asbestos_cord: "Cordão de amianto",
  asbestos_rope: "Corda de amianto",
  cork_coating: "Revestimento de cortiça",
  foil_rope: "Corda de folha metálica",
  tape: "Fita",
  wicking: "Pavio",

  textiles_felts_fabrics: "Têxteis, feltros, tecidos",
  asbestos_blanket: "Cobertor de amianto",
  asbestos_canvas: "Lona de amianto",
  asbestos_fabric: "Tecido de amianto",
  asbestos_felt: "Feltro de amianto",
  asbestos_lap: "Manta de amianto",
  asbestos_wool: "Lã de amianto",
  asbestos_thread: "Fio de amianto",
  lagging: "Isolamento de tubulação",
  roving: "Fibra contínua",
  textiles: "Têxteis",

  element_updated_successfully: "Elemento atualizado com sucesso",
  updating_element: "Atualizando elemento",
  link_to_google_maps: "Link para o Google Maps",
  link_to_google_earth: "Link para o Google Earth",
  PENDING: "Pendente",
  IN_REVIEW: "Em revisão",
  REVIEWED: "Revisado",
  CLEAR: "Limpo",
  change_grid_status: "Alterar status da grade para...",
  changing_grid_status: "Alterando status da grade",
  grid_status_changed_successfully: "Status da grade alterado com sucesso",
  BAJANTE: "Tubo de descida",
  LAB_MEASURES: "Medições laboratoriais",
  no_images: "Sem imagens",
  expand_image: "Expandir imagem",
  "Muy Alto": "Muito alto",
  Alto: "Alto",
  Medio: "Médio",
  Bajo: "Baixo",
  Industrial: "Industrial",
  Residencial: "Residencial",
  Oficinas: "Escritórios",
  Agrícola: "Agrícola",
  Retail: "Comercial",
  "Servicios Públicos": "Serviços Públicos",
  Otros: "Outros",
  Privado: "Privado",
  Público: "Público",
  Municipal: "Municipal",
  fx_pending: "Data pendente",
  fx_clear: "Data de limpeza",
  fx_review: "Data de revisão",
  link_to: "Link para...",
  ASBESTOS_SUSCEPTIBILIDAD: "Susceptibilidade ao amianto",
  building_refurbishing_date: "Data de reforma do edifício",
  cannot_display_image: "Não é possível exibir a imagem",
  close_image: "Fechar imagem",
  no_grid_to_update: "Nenhuma grade para atualizar",
  download_image: "Baixar imagem",
  save_geometry: "Salvar geometria",
  save_geometry_title: "Salvar geometria",
  save_geometry_body: "Tem certeza de que deseja salvar a geometria?",
  tags: "Tags",
  aois: "AOIs",
  show_info: "Mostrar informações",
  features: "Elementos",
  create_inventory_element: "Criar elemento de inventário...",
  point: "Ponto",
  polygon: "Polígono",
  invalid_geometry: "Geometria inválida",
  add_new_feature: "Adicionar novo elemento",
  IN_PROGRESS: "Em andamento",
  tooltipChangeGrid: "Regenerar grade",
  from_layer: "Da camada",
  small: "Pequeno",
  medium: "Médio",
  large: "Grande",
  select_layer: "Selecionar uma camada",
  size: "Tamanho",
  name_en: "Nome em inglês",
  name_es: "Nome em espanhol",
  regenerating_grid: "Regenerando grade",
  grid_regenerated_successfully: "Grade regenerada com sucesso",
  reset_rotation: "Redefinir rotação",
  "Sin datos": "Atual",
  "Cobertura arbórea": "Cobertura arbórea",
  Matorral: "Mato",
  Pastizales: "Pastagens",
  "Tierras de cultivo": "Terras agrícolas",
  "Área urbanizada": "Área urbanizada",
  "Vegetación escasa o desnuda": "Vegetação escassa ou solo exposto",
  "Cuerpos de agua permanentes": "Corpos de água permanentes",
  "Humedales herbáceos": "Pântanos herbáceos",
  Manglares: "Manguezais",
  "Musgos y líquenes": "Musgos e líquens",

  category: "Categoria",
  area_properties: "Propriedades da área",
  actual_ground_use_distribution: "Distribuição atual do uso do solo",
  market_value: "Valor de mercado",
  area_km2: "Área",
  market_value_euros: "Valor total",
  market_value_euros_per_km2: "Valor de mercado",
  carbon_Mg: "Carbono",
  carbon_Mg_per_km2: "Carbono",
  biomass_Mg: "Biomassa",
  biomass_Mg_per_km2: "Biomassa",
  biomass_tonnes: "Biomassa",
  biomass_tonnes_per_km2: "Biomassa",
  carbon_kg: "Carbono",
  carbon_kg_per_km2: "Carbono",
  biomass_kg: "Biomassa",
  biomass_kg_per_km2: "Biomassa",
  carbon_credits_tCO2e: "Créditos de carbono",
  carbon_credits_tCO2e_per_km2: "Créditos de carbono",
  carbon_credits: "Créditos de carbono",
  copy: "Copiar",
  copied: "Copiado!",
  geometry_error: "Geometria inválida",
  market_value_euros_per_m2: "Valor por área",
  expand: "Expandir",
  contract: "Contrair",
  unavailable: "Indisponível",
  data_filter_control: "Controle de filtro de dados",

  // TUTORIAL
  next: "Próximo",
  back: "Voltar",
  last: "Concluir",
  skip: "Pular",
  of: "de",
  tutorial_step_title_1: "Bem-vindo ao visualizador da Agforest",
  tutorial_step_body_1:
    "No tutorial a seguir, vamos te mostrar as funcionalidades do site.",
  tutorial_step_body_2: "Controles sobre o visualizador do mapa",
  tutorial_step_body_3: "Opções do menu lateral",
  tutorial_sidebar_button:
    "Aqui estão os seus projetos e as opções de camadas.",
  tutorial_user_directions_button: "Busca de endereços e opções do usuário.",
  tutorial_map_controls_button: "Controles básicos do mapa.",
  tutorial_attributions_button: "Atribuições das camadas.",
  tutorial_step_title_4: "Tutorial concluído",
  tutorial_step_body_4: "Aproveite sua experiência na Agforest! 😃😃",
  tutorial_my_projects_button:
    'Se você clicar em "Meus projetos", verá todos os projetos contratados.',
  tutorial_layers:
    "Os grupos de camadas, que por sua vez contêm camadas individuais, têm ações que você pode realizar em cada camada.",
  tutorial_tabs:
    "Altere as abas para acessar filtros ou painéis de controle, se houver.",
  finish: "Concluir",
  previous: "Anterior",
  select_language: "Selecionar idioma",
  tutorial_carbon_body_1:
    "Primeiro selecione a área do mapa que deseja analisar.",
  tutorial_carbon_title: "Estudo de Carbono",
  tutorial_carbon_body_2:
    "Nesta janela, você verá o resumo do estudo de carbono, onde poderá fazer testes.",
  tutorial_carbon_category:
    "Mude de categoria para ver as novas propriedades da área selecionada",
  show_tutorial: "Mostrar tutorial",
  tutorial_repeat: "Clique aqui para reiniciar o tutorial",
  carbon_quotes_graph_title:
    "Evolução diária do preço dos créditos de carbono (CC)",
  actual_carbon_quote: "Valor atual CC",
  carbon_quote: "Valor CC",
  download_geojson: "Transferir GeoJSON",
  downloading_geojson: "Transferindo GeoJSON",
  geojson_downloaded_successfully: "GeoJSON transferido com sucesso",
  geojson_downloading_error: "Erro ao transferir GeoJSON",
  layer_description: "Descrição da camada",
  updating_asbestos_presence:
    "Atualizando a presença de amianto no elemento selecionado",
  asbestos_presence_updated_successfully:
    "Presença de amianto atualizada com sucesso para",
  asbestos_presence_update_error: "Erro ao atualizar a presença de amianto",
  no_element_found: "Nenhum elemento encontrado",
  restore_asbestos_presence_title: "Restaurar presença de amianto",
  restore_asbestos_presence_body:
    "Tem certeza de que deseja restaurar a presença de amianto deste elemento?",
  restoring_asbestos_presence: "Restaurando a presença de amianto",
  asbestos_presence_restored_successfully:
    "Presença de amianto restaurada com sucesso para",
  change_asbestos_presence: "Alterar presença de amianto para...",
  open_settings: "Abrir configurações",
  settings: "Configurações",
  toggle_snap_guides: "Guias de encaixe",
  exit_draw_polygon_mode: "Finalizar desenho",

  accumulated_carbon_credits: "Créditos de carbono acumulados",
  co2_absoption_evolution: "Evolução da absorção de CO₂",
  "relation_tCO2/pie_tCO2/km2": "Relação tCO₂/pé - tCO₂/km²",
  accumulated_credits_by_class: "Créditos acumulados por classe",
  carbon_credits_per_class: "Créditos de carbono por classe",
  class: "Classe",
  select_classes: "Selecionar classes",
  year: "Ano",
  accumulated_absorption_tCO2_km2: "Absorção acumulada (tCO₂/km²)",
  accumulated_absorption_tCO2_ha: "Absorção acumulada (tCO₂/ha)",
  accumulated_absorption_tCO2_tree: "Absorção acumulada (tCO₂/pé)",
  constant_scenario: "Cenário constante",
  optimistic_scenario: "Cenário otimista",
  pessimistic_scenario: "Cenário pessimista",
  constante_scenario: "Cenário constante",
  optimista_scenario: "Cenário otimista",
  pesimista_scenario: "Cenário pessimista",
  select_scenario: "Selecionar cenário",

  // Espécies Portugal (ya traducidas)
  // "Agricultura com espaços naturais e seminaturais": "Agricultura com espaços naturais e seminaturais",
  // "Agricultura protegida e viveiros": "Agricultura protegida e viveiros",
  // "Albufeiras de barragens": "Albufeiras de barragens",
  // "Áreas em construção": "Áreas em construção",
  // Aterros: "Aterros",
  // Comércio: "Comércio",
  // "Culturas temporárias de sequeiro e regadio": "Culturas temporárias de sequeiro e regadio",
  // "Cursos de água naturais": "Cursos de água naturais",
  // "Equipamentos culturais": "Equipamentos culturais",
  // "Equipamentos de lazer": "Equipamentos de lazer",
  // "Florestas de castanheiro": "Florestas de castanheiro",
  // "Florestas de espécies invasoras": "Florestas de espécies invasoras",
  // "Florestas de eucalipto": "Florestas de eucalipto",
  // "Florestas de outras folhosas": "Florestas de outras folhosas",
  // "Florestas de outras resinosas": "Florestas de outras resinosas",
  // "Florestas de outros carvalhos": "Florestas de outros carvalhos",
  // "Florestas de pinheiro bravo": "Florestas de pinheiro bravo",
  // "Florestas de sobreiro": "Florestas de sobreiro",
  // Indústria: "Indústria",
  // "Infraestruturas de produção de energia renovável": "Infraestruturas de produção de energia renovável",
  // "Infraestruturas de tratamento de resíduos e águas residuais": "Infraestruturas de tratamento de resíduos e águas residuais",
  // "Infraestruturas para captação, tratamento e abastecimento de águas para consumo": "Infraestruturas para captação, tratamento e abastecimento de águas para consumo",
  // "Instalações agrícolas": "Instalações agrícolas",
  // "Instalações desportivas": "Instalações desportivas",
  // "Lixeiras e Sucatas": "Lixeiras e Sucatas",
  // Matos: "Matos",
  // "Mosaicos culturais e parcelares complexos": "Mosaicos culturais e parcelares complexos",
  // Olivais: "Olivais",
  // "Outros equipamentos e instalações turísticas": "Outros equipamentos e instalações turísticas",
  // "Parques e jardins": "Parques e jardins",
  // "Pastagens espontâneas": "Pastagens espontâneas",
  // "Pastagens melhoradas": "Pastagens melhoradas",
  // Pedreiras: "Pedreiras",
  // Pomares: "Pomares",
  // "Rede viária e espaços associados": "Rede viária e espaços associados",
  // "Tecido edificado contínuo predominantemente horizontal": "Tecido edificado contínuo predominantemente horizontal",
  // "Tecido edificado contínuo predominantemente vertical": "Tecido edificado contínuo predominantemente vertical",
  // "Tecido edificado descontínuo": "Tecido edificado descontínuo",
  // "Tecido edificado descontínuo esparso": "Tecido edificado descontínuo esparso",
  // "Vegetação esparsa": "Vegetação esparsa",
  // Vinhas: "Vinhas"

  absorption_evolution_per_class: "Evolução da absorção por classe",
  accumulated_carbon_by_class: "Carbono acumulado por classe",
  carbon_credit_projection_full_area:
    "Projeção de créditos de carbono (área total)",
  accumulated_credits_per_km2: "Créditos acumulados por km²",
  vegetation_state_distribution: "Distribuição do estado da vegetação",

  // Espécies Espanha
  "Abedul pubescens (Betula alba)": "Bétula pubescente (Betula alba)",
  "Acebo (Ilex aquifolium)": "Azevinho (Ilex aquifolium)",
  "Agrícola con arbolado": "Agrícola com arvoredo",
  "Aliso (Alnus glutinosa)": "Amieiro (Alnus glutinosa)",
  Arbolado: "Arvoredo",
  "Arce seudoplátano (Acer pseudoplatanus)":
    "Bordo falso-plátano (Acer pseudoplatanus)",
  "Avellano (Corylus avellana)": "Aveleira (Corylus avellana)",
  "Balsas y estanques": "Tanques e lagoas",
  "Bardaguera (Salix atrocinerea)": "Salgueiro-preto (Salix atrocinerea)",
  "Caminos y sendas": "Caminhos e trilhos",
  Carreteras: "Estradas",
  "Castaño (Castanea sativa)": "Castanheiro (Castanea sativa)",
  "Coberturas de agua": "Superfícies de água",
  "Construcción deportiva": "Construção desportiva",
  Coníferas: "Coníferas",
  "Coníferas genéricas": "Coníferas genéricas",
  Cultivos: "Culturas",
  "Cultivos herbáceos": "Culturas herbáceas",
  "Cursos de agua": "Cursos de água",
  Desconocido: "Desconhecido",
  Edificación: "Edificação",
  Embalses: "Albufeiras",
  "Eucalipto globulus (Eucalyptus globulus)":
    "Eucalipto-comum (Eucalyptus globulus)",
  "Eucalipto nitens (Eucalyptus nitens)":
    "Eucalipto-brilhante (Eucalyptus nitens)",
  "Fresno excelsior (Fraxinus excelsior)": "Freixo (Fraxinus excelsior)",
  "Frondosas caducifolias": "Folhosas caducifólias",
  "Frondosas genéricas": "Folhosas genéricas",
  "Frondosas perennifolias": "Folhosas perenifólias",
  "Frutales no cítricos": "Fruteiras não cítricas",
  "Haya (Fagus sylvatica)": "Faia (Fagus sylvatica)",
  Huerta: "Horta",
  "Madroño (Arbutus unedo )": "Medronheiro (Arbutus unedo)",
  Matorral: "Mato",
  "Otras construcciones": "Outras construções",
  Pastizal: "Pastagem",
  "Pastizal-matorral": "Mato-pastagem",
  "Pasto arbolado": "Pastagem arborizada",
  "Peral silvestre (Pyrus spp.": "Pereira-brava (Pyrus spp.)",
  "Pino pináster (Pinus pinaster)": "Pinheiro-bravo (Pinus pinaster)",
  "Pino radiata (Pinus radiata)": "Pinheiro-de-Monterey (Pinus radiata)",
  "Pino silvestre (Pinus sylvestris)": "Pinheiro-silvestre (Pinus sylvestris)",
  Piscina: "Piscina",
  Prados: "Prados",
  "Rebollo (Quercus pyrenaica)": "Carvalho-negral (Quercus pyrenaica)",
  "Red de transporte terrestre sin catalogar":
    "Rede de transporte terrestre não classificada",
  "Roble (Quercus petraea)": "Carvalho-alvarinho (Quercus petraea)",
  "Roble pedunculado (Quercus robur)": "Carvalho-robusto (Quercus robur)",
  "Serbal de cazadores (Sorbus aucuparia)":
    "Mostajeira-brava (Sorbus aucuparia)",
  "Seudotsuga (Pseudotsuga menziesii)":
    "Pseudotsuga / Abeto-de-Douglas (Pseudotsuga menziesii)",
  "Suelo no edificado": "Solo não edificado",
  "Terrenos con escasa o nula vegetación":
    "Terrenos com pouca ou nenhuma vegetação",
  Viñedo: "Vinha",
  "Vías urbanas": "Vias urbanas",
  "Zona abierta": "Zona aberta",
  "Zona verde artificial y arbolado urbano":
    "Zona verde artificial e arvoredo urbano",
  "Zonas de extracción": "Zonas de extração",
  "Zonas de vertido": "Zonas de despejo",
  "Zonas pavimentadas o selladas": "Zonas pavimentadas ou seladas",
  scenario: "Cenário",
  total_area_ha: "Área total (ha)",
  downloading_all_attached_files: "Baixando todos os arquivos anexados",
  all_attached_files_downloaded_successfully:
    "Todos os arquivos anexados baixados com sucesso",
  download_all_attachments_error: "Erro ao baixar todos os anexos",
  download_all_attachments: "Baixar todos os anexos",
  location_unavailable: "Localização indisponível",
};
export default locale;
